import { defineMessages } from "react-intl";

export const shortcutsMessages = defineMessages({
  search: {
    id: "VvhNCi",
    defaultMessage: "Command menu",
    description: "command menu shortcut",
  },
  playground: {
    id: "Cn6l5R",
    defaultMessage: "Playground",
    description: "playground shortcut",
  },
});
